import { z } from "zod";
const count = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
export const wovenMetricsSchema = z.object({
    woven_connections_active: count,
    woven_connections_max: count,
    woven_sessions_active: count,
    woven_sessions_max: count,
    woven_connections_total: count,
    woven_authenticate_rejected_total: count,
    woven_join_rejected_total: count,
    woven_publishes_total: count,
    woven_transform_publishes_total: count,
    woven_publish_bytes_received_total: count,
    woven_publish_bytes_delivered_total: count,
    woven_events_delivered_total: count,
    woven_queue_dropped_total: count,
    woven_queue_evicted_total: count,
});
export const networkLifetimeCountsSchema = z.object({
    connections: count,
    publishes: count,
    eventsDelivered: count,
    bytesReceived: count,
    bytesDelivered: count,
    queueDropped: count,
    queueEvicted: count,
});
export const networkStatusSchema = z.object({
    scope: z.literal("configured-node"),
    freshness: z.enum(["fresh", "stale", "unavailable"]),
    observedAt: z.string().datetime().nullable(),
    lastAttemptAt: z.string().datetime().nullable(),
    ageSeconds: z.number().nonnegative().nullable(),
    connectionsActive: count.nullable(),
    sessionsActive: count.nullable(),
    lifetime: networkLifetimeCountsSchema.nullable().default(null),
    lifetimeTracking: z
        .object({
        scope: z.enum(["durable", "process"]),
        trackedSince: z.string().datetime().nullable(),
        observedAt: z.string().datetime(),
    })
        .nullable()
        .optional(),
    publishesPerSecond: z.null(),
    operational: z.null(),
});
export const adminNetworkTelemetrySchema = networkStatusSchema.extend({
    enabled: z.boolean(),
    failure: z.enum(["disabled", "timeout", "upstream", "invalid", "oversized"]).nullable(),
    metrics: wovenMetricsSchema.nullable(),
    lifetimeFailure: z.enum(["identity-unavailable", "storage"]).nullable().optional(),
});
//# sourceMappingURL=network-telemetry.js.map